const minWidth = typeof window !== "undefined" && window.innerWidth;
const minHeight = typeof window !== "undefined" && window.innerHeight;

const styles = theme => ({
  textFieldL: {
    marginRight: theme.spacing.unit * 1,
    width: 320
  },
  textFieldR: {
    marginRight: theme.spacing.unit * 1,
    width: 580
  },
  targetHeading: {
    display: "flex",
    justifyContent: "space-between"
  },
  saveTarget: {
    backgroundColor: theme.palette.accent,
    "&:hover": {
      backgroundColor: "#fd5622"
    }
  },
  mainBody: {
    maxWidth: 650,
    display: "block",
    marginLeft: "auto",
    marginRight: "auto"
  },
  checkBox: {
    display: "block"
  },
  lookup: {
    fontSize: "1.2em",
    fontWeight: "bold"
  },
  textField: {
    marginRight: theme.spacing.unit * 1,
    display: "block",
    minWidth: minWidth / 2,
    marginBottom: 30
  },
  root: {
    flexGrow: 1,
    height: "100vh",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center"
  },
  block: {
    display: "block"
  },
  modal: {
    minHeight: 320,
    minWidth: 600,
    maxHeight: 600,
    maxWidth: 950,
    marginTop: theme.spacing.unit * 1,
    overflow: "auto"
  },
  modalHeader: {
    fontWeight: "600!important",
    fontSize: "1.2rem!important",
    textTransform: "none!important"
  },
  form: {
    height: 430,
    overflowY: "scroll"
  },
  button: {
    marginLeft: theme.spacing.unit * 1,
    backgroundColor: theme.palette.accent,
    color: "white",
    minWidth: 40
  },
  submit: {
    marginLeft: theme.spacing.unit * 1,
    backgroundColor: theme.palette.accent,
    color: "white"
  },
  close: {
    padding: 0,
    minWidth: 40
  },
  flex: {
    flex: 1
  },
  summary: {
    padding: theme.spacing.unit
  },
  noDataBox: {
    margin: 20
  },
  rootModal: {
    maxHeight: 600
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/job/newsignaltek/common/customdataedit/styles.js